import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
// eslint-disable-next-line boundaries/element-types
import { AssetVizHeatmapDisplayState } from 'features/assetViz'
import { isNil } from 'lodash'
import { Details } from 'pages/details/Details'
import { z } from 'zod'

// This is from src/pages/details/contexts/detailsPageSearchParams.ts
export const detailsSearchSchema = z.object({
  cdf: z.string().optional(),
  show3D: z.preprocess((value) => {
    if (isNil(value)) return true // Default to true if not provided
    return value
  }, z.boolean().optional()),
  minFilter: z.preprocess(
    (value) => {
      if (typeof value === 'string') {
        if (value === 'Infinity') return Infinity
        if (value === '-Infinity') return -Infinity
        const parsed = parseFloat(value)
        if (isNaN(parsed)) return undefined
        return parsed
      }
      return value // Pass through if already a number
    },
    z.number().optional() // Final schema expects a number
  ),
  maxFilter: z.preprocess(
    (value) => {
      if (typeof value === 'string') {
        if (value === 'Infinity') return Infinity
        if (value === '-Infinity') return -Infinity
        const parsed = parseFloat(value)
        if (isNaN(parsed)) return undefined
        return parsed
      }
      return value // Pass through if already a number
    },
    z.number().optional() // Final schema expects a number
  ),
  markupLayers: z.string().optional(),
  extension: z.string().optional(),
  indication: z.string().optional(),
  heatmapDisplayState: z.nativeEnum(AssetVizHeatmapDisplayState).optional(),
  inspectionId: z.string().optional(),
  visualInspectionId: z.string().optional(),
  markupLayerLabelVisibility: z.preprocess((value) => {
    if (typeof value === 'string') {
      return value.split(',').filter(Boolean)
    }
    return value
  }, z.array(z.string()).optional()),
})

export const Route = createFileRoute('/details/$entryID')({
  component: Details,
  validateSearch: zodValidator(detailsSearchSchema),
})
